import React from 'react';
import AutoSizer from 'react-virtualized-auto-sizer';
import {
  XYPlot,
  XAxis,
  YAxis,
  VerticalBarSeries,
  LabelSeries,
  HorizontalBarSeries
} from 'react-vis';

const labelPosition = (label: string) => {
  const labelsPositions = [-3, -6, -9, -11, -14, -16];

  if (!label || typeof labelsPositions[label.length - 1] === 'undefined')
    return labelsPositions[3];

  return labelsPositions[label.length - 1];
};

const Bar = ({
  data,
  showY,
  showX,
  showLabels,
  type = 'vertical'
}: {
  data: any;
  showY?: boolean;
  showX?: boolean;
  showLabels?: boolean;
  type?: 'horizontal' | 'vertical';
}) => {
  const labelsData = data.map((val: any) => {
    const isValueNegative = val.y < 0;
    return {
      x: val.x,
      y: val.y,
      yOffset: isValueNegative ? 15 : -15,
      xOffset: labelPosition(isValueNegative ? `-${val.label}` : val.label),
      label: isValueNegative ? `${val.label}` : val.label
    };
  });

  return (
    <AutoSizer>
      {({ height, width }: { height: any; width: any }) => {
        return (
          <XYPlot
            xType="ordinal"
            margin={{
              right: 0,
              top: 40,
              left: showY ? 45 : 0,
              bottom: 80
            }}
            width={width}
            height={height}
            style={{}}
          >
            {showLabels && (
              <LabelSeries data={labelsData} labelAnchorX="label" />
            )}
            {showX && (
              <XAxis
                tickFormat={(t: string) => {
                  const text = t.split(' ');
                  if (text.length <= 3) {
                    const firstRow = text.slice(0, 1);
                    const secondRow = text.slice(1);
                    return (
                      <tspan dy="1em" fill="#AAAEB3">
                        <tspan x="0" dy="1em">
                          {firstRow.join(' ')}
                        </tspan>
                        <tspan x="0" dy="1em">
                          {secondRow.join(' ')}
                        </tspan>
                      </tspan>
                    );
                  }
                  const firstRow = text.slice(0, 3);
                  const secondRow = text.slice(3);

                  return (
                    <tspan dy="1em" fill="#AAAEB3">
                      <tspan x="0" dy="1em">
                        {firstRow.join(' ')}
                      </tspan>
                      <tspan x="0" dy="1em">
                        {secondRow.join(' ')}
                      </tspan>
                    </tspan>
                  );
                }}
              />
            )}
            {showY && (
              <YAxis
                tickFormat={(t: any) => {
                  return <tspan fill="#AAAEB3">{`${t}%`}</tspan>;
                }}
              />
            )}
            {type === 'vertical' && (
              <VerticalBarSeries
                barWidth={0.6}
                colorType="literal"
                data={data}
              />
            )}
            {type === 'horizontal' && (
              <HorizontalBarSeries
                barWidth={0.6}
                colorType="literal"
                data={data}
              />
            )}
          </XYPlot>
        );
      }}
    </AutoSizer>
  );
};

export default Bar;
